// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__35Iq8","selects":"Documents_selects__EFLsb"};